const feedbackConstants = {
	SEND_FEEDBACK_FULFILLED: 'SEND_FEEDBACK_FULFILLED',
	SEND_FEEDBACK_ERROR: 'SEND_FEEDBACK_ERROR',
};

export default feedbackConstants;
